import PropTypes from "prop-types";
import React, { Component } from "react";
import { injectIntl, intlShape } from "react-intl";
import { Select } from "cxa-components";
import messages from "components/messagesDescription";

const formatOptions = (options, intl, currency, selectedOption) => {
  options.forEach(option => {
    let name;
    switch (option.type) {
      case "EO":
      case "EE":
        option.isSelected = !selectedOption || selectedOption === option.type;
        name = option.isSelected
          ? intl.formatMessage(messages.addDependatTextDescription)
          : intl.formatMessage(messages.noDependantDescription);
        break;
      case "ES":
        name = `${intl.formatMessage(messages.spouseDescription)}`;
        break;
      case "EC":
        name = `${intl.formatMessage(messages.childrenDescription)}`;
        break;
      case "EF":
        name = `${intl.formatMessage(messages.familyDescription)}`;
        break;
      default:
        name = option.priceLabelName ? option.priceLabelName : option.type;
        break;
    }
    option.name = `${name}${
      option.type !== "EE"
        ? " " +
          intl.formatNumber(option.price, {
            style: "currency",
            currencyDisplay: "code",
            currency: currency,
          })
        : ""
    }`;
  });
};
const DataPlans = [];
class PlanOptions extends Component {
  constructor(props) {
    super(props);
    DataPlans.push(props);
    this.planOptionDidChange = this.planOptionDidChange.bind(this);
    this.onAddDependant = this.onAddDependant.bind(this);
  }

  onAddDependant(e) {
    const { plan } = this.props;

    const dependantOptions = plan.options.filter(option => option.type !== "EE");
    const employeeOption = plan.options.find(item => item.type === "EE");

    if (e.target.checked) {
      if (dependantOptions && dependantOptions.length) {
        this.props.onChange(plan, dependantOptions[0].type);
      }
    } else if (employeeOption) {
      this.props.onChange(plan, employeeOption.type);
    }
  }

  planOptionDidChange(e) {
    if (this.props !== undefined) {
      this.props.onChange(this.props.plan, e.target.value);
      if (this.props.plan !== undefined && this.props.plan.dependancyOptions !== undefined) {
        const depenOptions = this.props.plan.dependancyOptions.map(
          depenOptions => depenOptions.benefitID
        );
        const plans = [];
        depenOptions.forEach(itemOptions => {
          DataPlans.filter(
            itemPlan =>
              itemPlan.showOptions !== undefined &&
              itemPlan.plan.options.length > 1 &&
              itemPlan.plan.dependancyOptions == null &&
              itemPlan.plan.isSelected &&
              itemPlan.plan.uniqueId.includes(itemOptions)
          ).forEach(item => plans.push(item));
        });

        plans.forEach(itemPlan => {
          itemPlan.onChange(itemPlan.plan, e.target.value);
        });
      }
    }
  }

  render() {
    const { plan, currency, intl } = this.props;
    const filteredOptions = (plan.options && [].concat(plan.options)) || [];

    // Don't render if there are one or fewer options
    if (filteredOptions <= 1) {
      return null;
    }

    const selectedOptions = filteredOptions.filter(option => option.isSelected);
    const selectedOption =
      selectedOptions.length && selectedOptions[selectedOptions.length - 1].type;
    const { isMemberOnly } = plan;

    formatOptions(filteredOptions, intl, currency, selectedOption);

    const canShowOptions =
      plan.planValue !== "0" && plan.groupValue !== "0" && filteredOptions.length;

    const selectOptions = filteredOptions.map((option, index) => (
      <option
        className="benefit-plan__dependant-selection"
        key={index}
        disabled={!option.isAvailable}
        value={option.type}
      >
        {option.name}
      </option>
    ));

    return (
      <div
        className="product-plan__options"
        aria-hidden={isMemberOnly || !plan.isAvailable || !canShowOptions}
      >
        {
          <Select
            id={`${plan.uniqueId}-${plan.planDescription.replace(/ /g, "")}-select`}
            onChange={this.planOptionDidChange}
            value={selectedOption}
          >
            {selectOptions}
          </Select>
        }
      </div>
    );
  }
}

PlanOptions.propTypes = {
  plan: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  currency: PropTypes.string,
};

export default injectIntl(PlanOptions);



// WEBPACK FOOTER //
// ./components/employee/shop/PlanOptions.js